import React from 'react';
import { Box } from '@mui/material';
import { ChatSuggestionChip } from './ChatSuggestionChip';

export interface ChatAction {
  label: string;
  icon: React.ComponentType<any>;
  onClick: () => void;
  variant?: 'contained' | 'outlined';
  color?: 'default' | 'primary' | 'secondary' | 'error' | 'success' | 'inherit';
  disabled?: boolean;
}

interface ChatActionGroupProps {
  actions: ChatAction[];
}

export const ChatActionGroup: React.FC<ChatActionGroupProps> = React.memo(({ actions }) => {
  return (
    <Box sx={{ display: 'flex', gap: 1, mt: 1.5, flexWrap: 'wrap' }}>
      {actions.map((act, idx) => {
        const IconComponent = act.icon;
        const mappedColor = act.color === 'inherit' ? 'default' : (act.color as any);
        return (
          <ChatSuggestionChip
            key={idx}
            label={act.label}
            icon={React.createElement(IconComponent, { sx: { fontSize: 16 } })}
            onClick={act.onClick}
            // variant={act.variant === 'contained' ? 'filled' : 'outlined'}
            color={mappedColor}
            disabled={act.disabled}
          />
        );
      })}
    </Box>
  );
});

ChatActionGroup.displayName = 'ChatActionGroup';
